import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__field.email {
    margin: 0 0 40px 0;
    &.with-error {
      margin-bottom: 68px;
    }
  }
`;
